<template>
	<div
		v-if="renderComponent"
		class="empty"
		data-cy="empty"
	>
		<div
			v-if="illustration"
			:class="`empty__illustration--${illustration}`"
			class="empty__illustration"
		/>

		<div
			v-else-if="hasIllustrationSlot"
			class="empty__illustration empty__illustration--custom"
		>
			<slot name="illustration" />
		</div>

		<h2
			v-if="title"
			class="empty__title"
		>
			{{ title }}
		</h2>

		<h6
			v-if="subtitle"
			class="empty__subtitle"
		>
			{{ subtitle }}
		</h6>

		<helio-button
			v-if="buttonText && buttonLink"
			:text="buttonText"
			:link="buttonLink"
			:color="buttonColor"
			class="empty__button"
		/>
	</div>
</template>

<script>
import Button from '../button/Button.vue';

export default {
	name: 'Empty',

	components: {
		'helio-button': Button,
	},

	props: {
		buttonColor: {
			type: String,
			required: false,
			default: null,
			description: 'Sets the color that will appear in the Button',
		},

		buttonLink: {
			type: [String, Object],
			required: false,
			default: null,
			description: 'Adds a link on the Button',
		},

		buttonText: {
			type: String,
			required: false,
			default: '',
			description: 'Sets the text that will appear in the Button',
		},

		illustration: {
			type: String,
			required: false,
			validator: value => [
				'feather',
				'folder',
				'search',
			].indexOf(value) !== -1,
			default: null,
			description: 'Sets the illustration that will appear in the empty container',
		},

		initialSubtitle: {
			type: String,
			required: false,
			default: null,
			description: 'Sets the subtitle that will appear in the empty container',
		},

		initialTitle: {
			type: String,
			required: true,
			description: 'Sets the title that will appear in the empty container',
		},
	},

	data() {
		return {
			title: null,
			subtitle: null,
			renderComponent: true,
		};
	},

	computed: {
		hasIllustrationSlot() {
			return !!this.$slots.illustration || !!this.$scopedSlots.illustration;
		},
	},

	watch: {
		initialTitle() {
			this.title = this.initialTitle;
			this.renderComponent = false;
		},

		initialSubtitle() {
			this.subtitle = this.initialSubtitle;
			this.renderComponent = false;
		},

		renderComponent() {
			if (!this.renderComponent) {
				this.$nextTick(() => {
					this.renderComponent = true;
				});
			}
		},
	},

	mounted() {
		this.title = this.initialTitle;
		this.subtitle = this.initialSubtitle;
	},
};
</script>

<style lang="scss" src="./empty.scss" />
